module.exports = __webpack_public_path__ + "static/img/9.187110f4.png";